export const getChildrenList = (parentList, parentInputId, childName, isObject = false, appendParentName = null) => {
    let selectedParentsString = document.getElementById(parentInputId).value;
    let selectedParentIds = selectedParentsString.split(",");

    let selectedParents = !(selectedParentIds.length === 1 && selectedParentIds[0] === '') ? parentList.filter(x => selectedParentIds.includes(x.id.toString())) : parentList;

    let children = [];
    selectedParents.forEach(p => {
        let concatArray = isObject ? Object.values(p[childName]) : p[childName];
        if (appendParentName) {
            concatArray = concatArray.map(x => {
                return {...x, name: x.name + " " + p[appendParentName]}
            })
        }
        children = children.concat(concatArray);
    })

    return children;
}

export const prepareJsonArray = (formJson, key, isNum = false) => {
    if (formJson[key]) {
        formJson[key] = formJson[key].split(",");
        if (isNum) {
            formJson[key] = formJson[key].map(x => Number(x));
        }

        return formJson[key]
    } else {
        return null;
    }
}

export const hideDuplicates = (arr) => {
    let returnArray = [];
    
    if (!arr) return returnArray;
    
    arr.forEach((elem) => {
        if (returnArray.filter(x => x.id === elem.id).length === 0) {
            returnArray.push(elem);
        }
    });
    
    return returnArray;
}